module.exports = "/images/ny-street-14.jpg";